import * as React from "react";

import { TextWrapper, TextQuestion, TextAnswer } from "./texts"

export const Faq = ({ faqs }) => {
    return (<TextWrapper>
        {faqs.map((faq: { question: string, answer: string }, index: number) => {
            return (<div key={index}>
                <TextQuestion text={faq.question} ></TextQuestion>
                <TextAnswer text={faq.answer} index={index}></TextAnswer>
            </div>)
        })}
    </TextWrapper>)
}